import { css } from 'styled-components';
import { up } from 'styled-breakpoints';
import {
  getTypography, getSpacing, TypographyName, SpacingName, BreakpointQueryName, ThemedFunctor, rem,
} from '@doveit/bricks';

const DESKTOP_LINES_NUMBER = 6;
const MOBILE_LINES_NUMBER = 8;

export const base: ThemedFunctor = ({
  theme,
}) => css`
  background-color: white;
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.SMALL, SpacingName.SMALL])}
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`

  > div {
    ${getTypography(theme, TypographyName.H4)}
  }

  > time {
    font-style: italic;
  }
`;

export const stars = css`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;

  ${up(BreakpointQueryName.MD)} {
    align-items: center;
  }
`;

export const star: ThemedFunctor = ({
  theme,
  full,
}) => css`
  color: ${full ? theme.palettes.brand.primary : theme.palettes.neutrals.light};
  line-height: 0;
`;

export const review: ThemedFunctor = ({
  theme,
}) => {
  const mobileFont = theme.typographyScale.BODY.variants.mobile;
  const mobileScale = rem(mobileFont.lineHeight, theme.remBase).replace('rem', '');
  const desktopFont = theme.typographyScale.BODY.variants.desktop;
  const desktopScale = rem(desktopFont.lineHeight, theme.remBase).replace('rem', '');

  return css`
    ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
    ${getTypography(theme, TypographyName.BODY)}
    display: -webkit-box;
    overflow: hidden;
    /* (font size * number of lines * line height) */
    height: calc(${mobileFont.size} * ${MOBILE_LINES_NUMBER} * ${mobileScale});
    -webkit-line-clamp: ${DESKTOP_LINES_NUMBER};
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;

    ${up(BreakpointQueryName.MD)} {
      height: calc(${desktopFont.size} * ${DESKTOP_LINES_NUMBER} * ${desktopScale});
    }
  `;
};

export const footer: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;
